const initialState = localStorage.getItem("fav") ? JSON.parse(localStorage.getItem("fav")) : []

const favReducer = (state = initialState, action) => {
    let {type, payload} = action;
    switch (type) {
        case "UPDATE_FAV":
            localStorage.setItem("fav", JSON.stringify(payload));
            return state;
        default:
            return state;
    }
};

export default favReducer;